import { Center, Loader, LoaderProps } from "@mantine/core";

interface LoadingProps extends LoaderProps {
  height?: string | number;
  size?: string | number;
  width?: string | number;
}

export default function Loading({
  height = "100dvh",
  size = 36,
  width = "100%",
  ...props
}: LoadingProps): JSX.Element {
  return (
    <Center w={width} h={height}>
      <Loader size={size} aria-label="Loading" {...props} />
    </Center>
  );
}
